import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Skip tracking on admin pages and for Emergent preview/dev traffic (testing, not customers)
    if (pathname.startsWith("/admin")) return undefined;
    const host = window.location.hostname;
    if (host.includes("emergentagent.com") || host.includes("emergent.sh")) return undefined;
    try {
      if (window.self !== window.top) {
        const ref = document.referrer || "";
        if (!ref || ref.includes("emergentagent.com") || ref.includes("emergent.sh")) return undefined;
      }
    } catch {
      return undefined; // cross-origin parent frame (embedding tool) — don't track
    }
    let cancelled = false;
    let id = null;
    const started = Date.now();

    const ping = (beacon) => {
      if (!id) return;
      const body = JSON.stringify({ id, seconds: Math.round((Date.now() - started) / 1000) });
      if (beacon && navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/analytics/ping`, new Blob([body], { type: "application/json" }));
      } else {
        fetch(`${API}/analytics/ping`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body,
          keepalive: true,
        }).catch(() => {});
      }
    };

    const params = new URLSearchParams(search);
    fetch(`${API}/analytics/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        referrer: document.referrer || null,
        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
      }),
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!cancelled && d?.id) id = d.id;
      })
      .catch(() => {});

    const timer = setInterval(() => ping(false), 15000);
    const onHide = () => ping(true);
    window.addEventListener("pagehide", onHide);
    document.addEventListener("visibilitychange", onHide);

    return () => {
      cancelled = true;
      clearInterval(timer);
      window.removeEventListener("pagehide", onHide);
      document.removeEventListener("visibilitychange", onHide);
      ping(true);
    };
  }, [pathname, search]);

  return null;
}
